<template>
  <div
    class="form-field-v2 w-full"
    :class="{ 'form-field-v2--error': hasError }"
  >
    <label
      v-if="label || $slots.label"
      :for="labelFor"
      class="flex flex-row items-center gap-1 mb-1.5 text-sm leading-5 font-normal"
      :class="labelColorClass"
    >
      <slot name="label">{{ label }}</slot>
      <span v-if="required" class="text-[#2ABB7F]">*</span>
      <span
        v-if="help"
        v-tooltip.top="help"
        class="material-symbols-outlined text-base/[16px] text-[#6B7280] cursor-help"
      >
        help
      </span>
    </label>
    <slot />
    <div
      v-if="hasError"
      class="form-field-v2__message mt-1.5 text-sm leading-5 text-[#B91C1C]"
    >
      {{ error }}
    </div>
    <div
      v-else-if="hint"
      class="form-field-v2__message mt-1.5 text-sm leading-5"
      :class="hintColorClass"
    >
      {{ hint }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormFieldV2',
  props: {
    label: { type: String, default: '' },
    hint: { type: String, default: '' },
    error: { type: String, default: '' },
    help: { type: String, default: '' },
    labelFor: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    strong: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  computed: {
    hasError() {
      return !!this.error;
    },
    hintColorClass() {
      if (this.disabled) return 'text-neutral-500';
      return this.strong ? 'text-gray-800' : 'text-gray-700';
    },
    labelColorClass() {
      return this.hasError ? 'text-[#B91C1C]' : this.hintColorClass;
    },
  },
};
</script>
